import script from "./TutorialSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialSection.vue?vue&type=script&setup=true&lang=js"

import "./TutorialSection.vue?vue&type=style&index=0&id=1bbaa870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bbaa870"]])

export default __exports__